// extracted by mini-css-extract-plugin
export default {"parent-mode":"dialog_parent-mode__4lpKW","dialogWrapper":"dialog_dialogWrapper__oSNwM","background":"dialog_background__GlyfZ","content":"dialog_content__Sd08E"};